import { Fragment, useContext, useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import * as Yup from 'yup';

import ErrorMessage from '../../../Components/Errors/ErrorMessage';
import {
  Datepicker,
  Form,
  Number,
  Select,
  Text,
  Textarea,
} from '../../../Components/Form';
import FileUploader from '../../../Components/Form/FileUpload';
import MultiSelect from '../../../Components/Form/MultiSelect';
import TextEditor from '../../../Components/Form/TextEditor';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import {
  dateToJalali,
  genders,
  getPhotoId,
  getStatus,
  serverErrorHandler,
} from '../../../Utils/Helpers';
import { CompetitionContext } from '../Context/CompetitionContext';
import { getBestCoach } from '../Utils/Helper';

const validationSchema = Yup.object({
  title: Yup.string()
    .typeError('عنوان الزامی است')
    .required('عنوان الزامی است')
    .max(190, 'عنوان نمی تواند بیشتر از 190 کاراکتر باشد'),
  sku: Yup.string().required('شناسه مسابقه الزامی است'),
  weights: Yup.array()
    .typeError('انتخاب وزن الزامی است')
    .required('انتخاب وزن الزامی است'),
  level_id: Yup.number()
    .typeError('انتخاب سطح مسابقه الزامی است')
    .required('انتخاب سطح مسابقه الزامی است'),
  // province_id: Yup.number().typeError('').nullable(),
  ages: Yup.array()
    .typeError('انتخاب رده های سنی الزامی است')
    .required('انتخاب رده های سنی الزامی است'),
  thumbnail: Yup.array()
    .typeError('انتخاب تصویر الزامی است')
    .required('انتخاب تصویر الزامی است'),
  type: Yup.number()
    .typeError('انتخاب نوع الزامی است')
    .required('انتخاب نوع الزامی است'),
  sports: Yup.array()
    .typeError('انتخاب رشته های ورزشی الزامی است')
    .required('انتخاب رشته های ورزشی الزامی است'),
  provinces: Yup.array()
    .typeError('انتخاب استان ها الزامی است')
    .required('انتخاب استان ها الزامی است'),
  coach_count: Yup.number()
    .typeError('تعداد مربی الزامی است')
    .required('تعداد مربی الزامی است'),
  supervisor_count: Yup.number()
    .typeError('تعداد سرپرست الزامی است')
    .required('تعداد سرپرست الزامی است'),
  description: Yup.string().required('توضیحات الزامی است'),
  address: Yup.string().required('آدرس محل برگزاری الزامی است'),
  gender: Yup.number()
    .typeError('انتخاب جنسیت الزامی است')
    .required('انتخاب جنسیت الزامی است'),
  start_at: Yup.string().required('تاریخ شروع مسابقه الزامی است'),
  end_at: Yup.string().required('تاریخ پایان مسابقه الزامی است'),
  start_register_at: Yup.string().required(
    'تاریخ شروع ثبت نام مسابقه الزامی است',
  ),
  end_register_at: Yup.string().required(
    'تاریخ پایان ثبت نام مسابقه الزامی است',
  ),
  sport_count_select: Yup.number()
    .typeError('انتخاب تعداد رشته انتخابی الزامی است')
    .required('انتخاب تعداد رشته انتخابی الزامی است'),
  best_coach: Yup.number()
    .typeError('انتخاب مربی برتر الزامی است')
    .required('انتخاب مربی برتر الزامی است'),
  // id_card_id: Yup.number().typeError('').nullable(),
  // id_card_team_id: Yup.number().typeError('').nullable(),
  // id_card_league_id: Yup.number().typeError('').nullable(),
  // rank_card_id: Yup.number().typeError('').nullable(),
  // rank_card_team_id: Yup.number().typeError('').nullable(),
  // rank_card_league_id: Yup.number().typeError('').nullable(),
  // id_card_supervisor_id: Yup.number().typeError('').nullable(),
  // rank_card_supervisor_id: Yup.number().typeError('').nullable(),
  // id_card_coach_id: Yup.number().typeError('').nullable(),
  // rank_card_coach_id: Yup.number().typeError('').nullable(),
  status: Yup.number()
    .typeError('انتخاب وضعیت الزامی است')
    .required('انتخاب وضعیت الزامی است'),
});

const Create = () => {
  const { id } = useParams();
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [provinceErrors, setProvinceErrors] = useState({});
  const [serverErrors, setServerErrors] = useState({});
  const { get, put } = useApi();
  const { error, success } = useToast();
  const context = useContext(CompetitionContext);
  const [loading, setLoading] = useState(true);
  const [provinces, setProvinces] = useState([]);
  const [changeAllProvinceLoading, setChangeAllProvinceLoading] =
    useState(false);

  useEffect(() => {
    const getData = async () => {
      await getCompetition();
      await getSports();
      await getLevels();
      await getTypes();
      await getWeights();
      await getProvinces();
      await getIDCards();
      await getAges();
    };
    getData();
  }, [id]);

  const getSports = async () => {
    setLoading(true);
    await get(
      '/sport?all=true',
      (res) => {
        context.sports = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getLevels = async () => {
    setLoading(true);
    await get(
      '/level?all=true',
      (res) => {
        context.levels = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getTypes = async () => {
    setLoading(true);
    await get(
      '/competition/type',
      (res) => {
        context.types = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getWeights = async () => {
    setLoading(true);
    await get(
      '/weight?all=true',
      (res) => {
        context.weights = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getProvinces = async () => {
    setLoading(true);
    await get(
      '/province',
      (res) => {
        context.provinces = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getIDCards = async () => {
    setLoading(true);
    await get(
      '/id-card?all=true',
      (res) => {
        context.IDCards = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };
  const getAges = async () => {
    setLoading(true);
    await get(
      '/age?all=true',
      (res) => {
        context.ages = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const onChangeAllProvince = async (name, value) => {
    setChangeAllProvinceLoading(true);
    const provincesCopy = await [...provinces];
    let provinceTotal = await provincesCopy?.map((p) => {
      p[name] = value;
      return p;
    });
    await setProvinces(provinceTotal);
    setChangeAllProvinceLoading(false);
  };

  const getCompetition = async (editLoading = false) => {
    setLoading(true);
    await get(
      `/competition/${id}`,
      (res) => {
        const data = res.data;
        context.competition = data;
        let provinceList = data?.provinces?.map((p) => {
          let province = p;
          province['single_count'] = p.pivot?.single_count;
          province['team_count'] = p.pivot?.team_count;
          province['league_count'] = p.pivot?.league_count;
          return province;
        });
        setProvinces(provinceList);
        if (editLoading) {
          setLoading(false);
        }
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    setFormSubmitLoaing(true);
    let error = false;
    let errors = {};
    for (let province of provinces) {
      if (
        province?.single_count === undefined ||
        province?.team_count === undefined ||
        province?.league_count === undefined
      ) {
        error = true;
        errors[province?.id] = `تعداد استان ${province?.name} نباید خالی باشد`;
      }
    }

    values['id_card_id'] =
      values?.id_card_id == 'null' ? null : values?.id_card_id;
    values['rank_card_id'] =
      values?.rank_card_id == 'null' ? null : values?.rank_card_id;
    values['id_card_team_id'] =
      values?.id_card_team_id == 'null' ? null : values?.id_card_team_id;
    values['id_card_league_id'] =
      values?.id_card_league_id == 'null' ? null : values?.id_card_league_id;
    values['rank_card_team_id'] =
      values?.rank_card_team_id == 'null' ? null : values?.rank_card_team_id;
    values['rank_card_league_id'] =
      values?.rank_card_league_id == 'null'
        ? null
        : values?.rank_card_league_id;
    values['id_card_supervisor_id'] =
      values?.id_card_supervisor_id == 'null'
        ? null
        : values?.id_card_supervisor_id;
    values['rank_card_supervisor_id'] =
      values?.rank_card_supervisor_id == 'null'
        ? null
        : values?.rank_card_supervisor_id;
    values['id_card_coach_id'] =
      values?.id_card_coach_id == 'null' ? null : values?.id_card_coach_id;
    values['rank_card_coach_id'] =
      values?.rank_card_coach_id == 'null' ? null : values?.rank_card_coach_id;

    values['province_id'] =
      values?.province_id == 'null' ? null : values?.province_id;

    if (error) {
      setProvinceErrors(errors);
      setFormSubmitLoaing(false);
      return;
    }
    setProvinceErrors({});

    values['thumbnail_id'] = getPhotoId(values['thumbnail'], false);
    values['provinces'] = provinces?.map((p) => {
      return {
        id: p.id,
        single_count: p.single_count,
        team_count: p.team_count,
        league_count: p.league_count,
      };
    });
    await put(
      `/competition/${id}`,
      values,
      (res) => {
        success(`مسابقه "${values?.title}" باموفقیت ویرایش شد.`);
        setFormSubmitLoaing(false);
        getCompetition(true);
      },
      (err) => {
        setFormSubmitLoaing(false);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`مسابقه "${values?.title}" به علت خطا ایجاد نشد.`);
        }
      },
    );
  };

  const onChangeProvince = (name, provinceId, value) => {
    const provincesCopy = [...provinces];
    let provinceIndex = provincesCopy.findIndex((p) => p.id === provinceId);
    provincesCopy[provinceIndex][name] = value;
    setProvinces(provincesCopy);
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title='ویرایش مسابقه'
        showBackBtn={true}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/competition'
      />
      <Form
        initialValues={{
          title: context?.competition?.title,
          level_id: context?.competition?.level?.id,
          province_id: context?.competition?.province?.id,
          thumbnail: [],
          type: context?.competition?.type?.map((t) => t.id) ?? [],
          sports: context?.competition?.sports?.map((s) => s?.id) ?? [],
          provinces: [],
          ages: context?.competition?.ages?.map((a) => a?.id) ?? [],
          weights: context?.competition?.weights?.map((w) => w?.id) ?? [],
          coach_count: context?.competition?.coach_count,
          supervisor_count: context?.competition?.supervisor_count,
          description: context?.competition?.description,
          address: context?.competition?.address,
          gender: context?.competition?.gender,
          start_at: dateToJalali(context?.competition?.start_at),
          end_at: dateToJalali(context?.competition?.end_at),
          sku: context?.competition?.sku,
          start_register_at: dateToJalali(
            context?.competition?.start_register_at,
          ),
          end_register_at: dateToJalali(context?.competition?.end_register_at),
          sport_count_select: context?.competition?.sport_count_select,
          best_coach: context?.competition?.best_coach,
          id_card_id: context?.competition?.IDCard?.id,
          id_card_team_id: context?.competition?.idCardTeamId?.id,
          id_card_league_id: context?.competition?.idCardLeagueId?.id,
          rank_card_id: context?.competition?.RankIDCard?.id,
          rank_card_team_id: context?.competition?.rankCardTeamId?.id,
          rank_card_league_id: context?.competition?.rankCardLeagueId?.id,
          id_card_supervisor_id: context?.competition?.id_card_supervisor?.id,
          rank_card_supervisor_id:
            context?.competition?.rank_card_supervisor?.id,
          id_card_coach_id: context?.competition?.id_card_coach?.id,
          rank_card_coach_id: context?.competition?.rank_card_coach?.id,
          status: context?.competition?.status,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='عنوان'
                  name='title'
                  serverError={serverErrors.title}
                />
              </div>
              <div className='col-12'>
                <Text
                  title='شناسه مسابقه'
                  name='sku'
                  serverError={serverErrors.sku}
                />
              </div>
              <div className='col-12'>
                <Number
                  title='تعداد رشته های انتخابی'
                  name='sport_count_select'
                  serverError={serverErrors.sport_count_select}
                />
              </div>
              <div className='col-12'>
                <MultiSelect
                  title='رشته های ورزشی'
                  defaultValue={context.competition?.sports}
                  name='sports'
                  getOptionLabel={(t) => t?.title}
                  getOptionValue={(t) => t?.id}
                  options={context.sports}
                  serverError={serverErrors.sports}
                />
              </div>
              <div className='col-12'>
                <MultiSelect
                  defaultValue={context.competition?.ages}
                  title='رده های سنی'
                  name='ages'
                  getOptionLabel={(t) => t?.title}
                  getOptionValue={(t) => t?.id}
                  options={context.ages}
                  serverError={serverErrors?.ages}
                />
              </div>
              <div className='col-12'>
                <MultiSelect
                  defaultValue={context.competition?.weights}
                  title='اوزان'
                  name='weights'
                  getOptionLabel={(t) => t?.weight}
                  getOptionValue={(t) => t?.id}
                  options={context.weights}
                  serverError={serverErrors?.weights}
                />
              </div>
              <div className='col-12'>
                <TextEditor
                  title='توضیحات'
                  name='description'
                  serverError={serverErrors?.description}
                />
              </div>
              <div className='col-12'>
                <MultiSelect
                  defaultValue={context.competition?.provinces}
                  title='استان ها'
                  name='provinces'
                  getOptionLabel={(t) => t?.name}
                  getOptionValue={(t) => t?.id}
                  options={context.provinces}
                  serverError={serverErrors?.provinces}
                  onChange={setProvinces}
                />
              </div>
              {provinces?.length > 0 && (
                <>
                  <div className='row mx-3 rounded-1 justify-start border border-secondary w-100 mb-3'>
                    <div className='col-12'>
                      <div className='d-flex flex-row justify-start'>
                        <h1 className='text-secondary f-14 font-weight-bold my-2'>
                          تعداد ثابت
                        </h1>
                      </div>
                    </div>
                    <div className='col-4'>
                      <Number
                        title='تعداد یکسان برای همه انفرادی ها'
                        formikOnChange={false}
                        onChange={(value) =>
                          onChangeAllProvince('single_count', value)
                        }
                      />
                    </div>
                    <div className='col-4'>
                      <Number
                        title='تعداد یکسان برای همه تیم ها'
                        formikOnChange={false}
                        onChange={(value) =>
                          onChangeAllProvince('team_count', value)
                        }
                      />
                    </div>
                    <div className='col-4'>
                      <Number
                        title='تعداد یکسان برای همه لیگ ها'
                        formikOnChange={false}
                        onChange={(value) =>
                          onChangeAllProvince('league_count', value)
                        }
                      />
                    </div>
                  </div>
                </>
              )}
              {provinces?.map((province) => (
                <Fragment key={province?.id}>
                  <div className='col-12 col-md-4'>
                    <Number
                      title={`تعداد انفرادی استان ${province.name}`}
                      name='province'
                      defaultValue={province?.single_count}
                      serverError={serverErrors.provinces}
                      formikOnChange={false}
                      onChange={(value) =>
                        onChangeProvince('single_count', province?.id, value)
                      }
                    />
                    <ErrorMessage
                      error={provinceErrors?.[province?.id]}
                      classes='my-2'
                    />
                  </div>
                  <div className='col-12 col-md-4'>
                    <Number
                      title={`تعداد تیم استان ${province.name}`}
                      name='province'
                      defaultValue={province?.team_count}
                      serverError={serverErrors.provinces}
                      formikOnChange={false}
                      onChange={(value) =>
                        onChangeProvince('team_count', province?.id, value)
                      }
                    />
                    <ErrorMessage
                      error={provinceErrors?.[province?.id]}
                      classes='my-2'
                    />
                  </div>
                  <div className='col-12 col-md-4'>
                    <Number
                      title={`تعداد تیم لیگ برای استان ${province.name}`}
                      name='province'
                      defaultValue={province?.league_count}
                      serverError={serverErrors.provinces}
                      formikOnChange={false}
                      onChange={(value) =>
                        onChangeProvince('league_count', province?.id, value)
                      }
                    />
                    <ErrorMessage
                      error={provinceErrors?.[province?.id]}
                      classes='my-2'
                    />
                  </div>
                </Fragment>
              ))}
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <MultiSelect
                defaultValue={context.competition?.type}
                title='نوع مسابقه'
                name='type'
                getOptionLabel={(t) => t?.title}
                getOptionValue={(t) => t?.id}
                options={context.types}
                serverError={serverErrors.type}
              />
            </div>
            <div className='col-12'>
              <Select
                title='ای دی کارت انفرادی'
                selectedElementExists={true}
                name='id_card_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 0)}
                serverError={serverErrors.id_card_id}
              />
            </div>
            <div className='col-12'>
              <Select
                title='ای دی کارت تیمی'
                selectedElementExists={true}
                name='id_card_team_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 0)}
                serverError={serverErrors.id_card_team_id}
              />
            </div>
            <div className='col-12'>
              <Select
                title='ای دی کارت لیگ'
                selectedElementExists={true}
                name='id_card_league_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 0)}
                serverError={serverErrors.id_card_league_id}
              />
            </div>
            <div className='col-12'>
              <Select
                title='ای دی کارت سرپرست'
                selectedElementExists={true}
                name='id_card_supervisor_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 0)}
                serverError={serverErrors.id_card_supervisor_id}
              />
            </div>
            <div className='col-12'>
              <Select
                title='ای دی کارت مربیان'
                selectedElementExists={true}
                name='id_card_coach_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 0)}
                serverError={serverErrors.id_card_coach_id}
              />
            </div>
            <div className='col-12'>
              <Select
                selectedElementExists={true}
                title='حکم انفرادی'
                name='rank_card_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 1)}
                serverError={serverErrors.rank_card_id}
              />
            </div>
            <div className='col-12'>
              <Select
                selectedElementExists={true}
                title='حکم تیمی'
                name='rank_card_team_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 1)}
                serverError={serverErrors.rank_card_team_id}
              />
            </div>
            <div className='col-12'>
              <Select
                selectedElementExists={true}
                title='حکم لیگ'
                name='rank_card_league_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 1)}
                serverError={serverErrors.rank_card_league_id}
              />
            </div>
            <div className='col-12'>
              <Select
                selectedElementExists={true}
                title='حکم سرپرست'
                name='rank_card_supervisor_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 1)}
                serverError={serverErrors.rank_card_supervisor_id}
              />
            </div>
            <div className='col-12'>
              <Select
                selectedElementExists={true}
                title='حکم مربیان'
                name='rank_card_coach_id'
                optionLabel='title'
                optionValue='id'
                options={context.IDCards?.filter((i) => i.type == 1)}
                serverError={serverErrors.rank_card_coach_id}
              />
            </div>
            <div className='col-12'>
              <Select
                title='سطح مسابقه'
                name='level_id'
                optionLabel='title'
                optionValue='id'
                options={context.levels}
                serverError={serverErrors.levle_id}
              />
            </div>
            <div className='col-12'>
              <Select
                title='جنسیت'
                name='gender'
                optionLabel='label'
                optionValue='value'
                options={genders()}
                serverError={serverErrors.gender}
              />
            </div>
            <div className='col-12'>
              <Number
                name='coach_count'
                title='تعداد مربیان'
                serverError={serverErrors?.coach_count}
              />
            </div>
            <div className='col-12'>
              <Number
                name='supervisor_count'
                title='تعداد سرپرست'
                serverError={serverErrors?.supervisor_count}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                title='شروع مسابقه'
                name='start_at'
                minDate={new Date('1830/01/01')}
                serverError={serverErrors.start_at}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                title='پایان مسابقه'
                name='end_at'
                minDate={new Date('1830/01/01')}
                serverError={serverErrors.end_at}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                title='شروع ثبت نام مسابقه'
                name='start_register_at'
                minDate={new Date('1830/01/01')}
                serverError={serverErrors.start_register_at}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                title='پایان ثبت نام مسابقه'
                name='end_register_at'
                minDate={new Date('1830/01/01')}
                serverError={serverErrors.end_register_at}
              />
            </div>
            <div className='col-12'>
              <Select
                selectedElementExists={true}
                title='استان محل برگزاری'
                name='province_id'
                optionLabel='name'
                optionValue='id'
                options={context?.provinces}
                serverError={serverErrors.province_id}
              />
            </div>
            <div className='col-12'>
              <Textarea
                title='آدرس محل برگزاری'
                name='address'
                serverError={serverErrors.address}
              />
            </div>
            <div className='col-12'>
              <div className='d-flex flex-row'>
                <img
                  className='img-thumbnail'
                  src={context.competition?.thumbnail?.path}
                  style={{ width: '350px', height: '200px' }}
                  alt=''
                />
              </div>
              <FileUploader
                method='post'
                name='thumbnail'
                title='تصویر مسابقه'
                maxFileSize='1024KB'
                allowMultiple={false}
                roles={['image/jpg', 'image/jpeg', 'image/png']}
                serverUrl='/file?location=gyms&public=1'
                maxFiles={1}
                serverError={serverErrors.thumbnail}
              />
            </div>
            <div className='col-12'>
              <Select
                title='انتخاب مربی برتر'
                name='best_coach'
                optionLabel='label'
                optionValue='value'
                options={getBestCoach()}
                serverError={serverErrors.best_coach}
              />
            </div>
            <div className='col-12'>
              <Select
                title='وضعیت'
                name='status'
                optionLabel='label'
                optionValue='value'
                options={getStatus()}
                serverError={serverErrors.status}
              />
            </div>
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
